import { useState } from "react";
import Sidebar from "../components/Sidebar.jsx";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

export default function AddUser() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    logoUrl: "",
    userType: "",
    template: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    // 🔴 Required field validation
    if (!formData.firstName.trim()) {
      toast.error("First Name is required");
      return;
    }

    if (!formData.lastName.trim()) {
      toast.error("Last Name is required");
      return;
    }

    if (!formData.email.trim()) {
      toast.error("Email is required");
      return;
    }

    if (!formData.phoneNumber.trim()) {
      toast.error("Mobile Number is required");
      return;
    }

    if (!formData.password) {
      toast.error("Password is required");
      return;
    }

    if (!formData.confirmPassword) {
      toast.error("Confirm Password is required");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error("Password and Confirm Password do not match");
      return;
    }

    if (!formData.userType) {
      toast.error("User Type is required");
      return;
    }

    if (!formData.template) {
      toast.error("Template is required");
      return;
    }

    // ✅ All good
    localStorage.setItem("addUserData", JSON.stringify(formData));
    navigate("/add-devices");
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <Toaster position="top-right" />

      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8">
        {/* Step Header */}
        <div className="flex justify-center gap-40 mb-10">
          <div className="text-center">
            <div className="h-3 w-3 bg-green-700 ml-12 rounded-full mx-auto mb-1" />
            <span className="text-green-700 ml-8 text-sm font-semibold">
              Add User
            </span>
          </div>
          <div className="text-center ">
            <div className="h-3 w-3 bg-green-700
             rounded-full mx-auto mb-1" />
            <span className="text-sm text-green-700 font-semibold">Add Devices</span>
          </div>
        </div>

        {/* Form */}
        <div className="max-w-2xl mx-auto space-y-4">
          {[
            ["First Name", "firstName"],
            ["Last Name", "lastName"],
            ["Email ID", "email"],
            ["Mobile Number", "phoneNumber"],
          ].map(([label, name]) => (
            <div
              key={name}
              className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center"
            >
              <label className="text-sm font-medium md:text-right pr-12">
                {label}
              </label>

              <input
                name={name}
                placeholder={`Enter ${label}`}
                onChange={handleChange}
                className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
              />
            </div>
          ))}

          {/* Password */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
            <label className="text-sm font-medium md:text-right pr-12">
              Password
            </label>

            <div className="md:col-span-2 relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Enter Password"
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded-md text-sm pr-10"
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-2.5 cursor-pointer text-gray-500"
              >
                {showPassword ? "🙈" : "👁"}
              </span>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
            <label className="text-sm font-medium md:text-right pr-12">
              Confirm Password
            </label>

            <div className="md:col-span-2 relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Enter Confirm Password"
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded-md text-sm pr-10"
              />

              <span
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute right-3 top-2.5 cursor-pointer text-gray-500"
              >
                {showConfirmPassword ? "🙈" : "👁"}
              </span>
            </div>
          </div>

          {/* Logo URL */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
            <label className="text-sm font-medium md:text-right pr-12">
              Logo Url
            </label>

            <input
              type="text"
              name="logoUrl"
              placeholder="Paste logo image URL"
              value={formData.logoUrl}
              onChange={handleChange}
              className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
            />
          </div>

          {/* User Type */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
            <label className="text-sm font-medium md:text-right pr-12">
              User Type
            </label>

            <select
              name="userType"
              onChange={handleChange}
              className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
            >
              <option value="">Select User Type</option>
              <option value="FARMER">Farmer</option>
              <option value="ADMIN">Admin</option>
              <option value="VET">Veterinarian</option>
            </select>
          </div>

          {/* Template Dropdown */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 items-center">
            <label className="text-sm font-medium md:text-right pr-12">
              Template
            </label>

            <select
              name="template"
              onChange={handleChange}
              className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
            >
              <option value="">Select Template</option>
              {[...Array(10)].map((_, i) => (
                <option key={i + 1} value={` ${i + 1}`}>
                  {i + 1}
                </option>
              ))}
            </select>
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-4 pt-6">
            <button
              onClick={() => navigate("/all-users")}
              className="border px-6 py-2 rounded-md text-sm"
            >
              Cancel
            </button>

            <button
              onClick={handleNext}
              className="bg-green-500 text-white px-6 py-2 rounded-md text-sm"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
